// 0000-0000
const mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /[X0-9]/i];

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
